// extracted by mini-css-extract-plugin
export default {"container":"style-module--container--e3ad5","placesList":"style-module--placesList--c47cc","link":"style-module--link--cf30d"};